import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleComponents'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleComponentsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleComponentsStore",
			variables: true,
		})
	}
}

export async function load_VehicleComponents(params) {
  await initClient()

	const store = new VehicleComponentsStore()

	await store.fetch(params)

	return {
		VehicleComponents: store,
	}
}
